export const secretaria_financeiro = [
  {
    id: "financeiro",
    label: "Financeiro",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "links",
      options: [
        {
          label: "Pagamento",
          type: "button-link",
          helpText:
            "Pagamento com débito ou crédito disponível apenas presencialmente.",
          href: "https://app.redeprocursos.com.br/financeiro",
        },
        {
          label: "Negociação de Débito",
          type: "button-link",
          helpText:
            "Para negociação, acesse o chat e solicite atendimento com o financeiro.",
          href: "https://api.whatsapp.com/send/?phone=557199885711&text=Ol%C3%A1%2C+gostaria+de+iniciar+meu+atendimento%21&type=phone_number&app_absent=0",
        },
        {
          label: "Antecipação de Mensalidade",
          type: "button-link",
          helpText:
            "Para antecipação de mensalidades, acesse o chat e solicite suas mensalidades",
          href: "https://api.whatsapp.com/send/?phone=557199885711&text=Ol%C3%A1%2C+gostaria+de+iniciar+meu+atendimento%21&type=phone_number&app_absent=0",
        },
      ],
    },
  },
  {
    id: "declaracao-de-matricula",
    label: "Declaração de Matrícula",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },     
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para a declaração de matrícula.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "declaracao-de-vacinacao",
    label: "Declaração de Vacinação",
    prazo: "24hrs",
  hideIn: "/setor/secretaria",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para a declaração de matrícula.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "declaracao-de-conclusao-de-curso",
    label: "Declaração de Conclusão de Curso",
    prazo: "3 dias",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "nomes_pais",
          label: "Nomes dos pais",
          helpText:
            "Apenas os alunos de enfermagem precisam enviar o nome dos pais",
          component: "InputText",
          type: "text",
          defaultValue: "",
          optional: true,
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "data_conclusao",
          label: "Data da conclusão do curso",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "atestado-de-frequencia",
    label: "Atestado de Frequência",
    prazo: "72hrs",
    prazo_minutos: 4320,
    hideIn: "/setor/secretaria",
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para o atestado.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "nota-fiscal",
    label: "Nota Fiscal",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para a declaração de matrícula.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "periodo",
          label: "Período da Nota Fiscal",
          helpText: "Informe os meses ou ano desejado",
          component: "InputMultText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "salvador-card",
    label: "Salvador Card",
    prazo: "0",
    prazo_minutos: 0,
    view: {
      type: "select",
      options: [
        {
          id: "inclusao-no-salvador-card",
          label: "Inclusão no salvador card",
          href: "/secretaria",
        },
        {
          id: "declaracao-para-apresentacao-no-salvador-card",
          label: "Declaração para salvador card",
          href: "/secretaria",
        },
        {
          id: "problemas-com-o-salvador-card",
          label: "Problemas com o salvador card",
          href: "/secretaria",
        },
      ],
    },
  },
  {
    id: "diploma",
    label: "Diploma",
    prazo: "",
    prazo_minutos: 0,
    view: {
      type: "links",
      options: [
        {
          label: "Acessar",
          type: "button-link",
          helpText:
            "Para solicitar seu diploma, acesse nossa plataforma de solicitação clicando no botão abaixo.",
          href: "https://requerimento.redeprocursos.com.br",
        },
      ],
    },
  },
  {
    id: "solicitacao-de-historico",
    label: "Solicitação de histórico",
    prazo: "45 dias",
    prazo_minutos: 64800,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "entrega-de-documentos",
    label: "Entrega de Documentos",
    prazo: "",
    prazo_minutos: 0,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "arquivo_rg",
          label: "Arquivo RG (Frente)",
          helpText: "Envie apenas a frente do RG.",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "arquivo_rg_verso",
          label: "Arquivo RG (Verso)",
          helpText: "Envie apenas o verso do RG.",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "arquivo_cpf",
          label: "Arquivo (CPF)",
          helpText: "",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "arquivo_comprovante_residencia",
          label: "Arquivo (Comprovante residência)",
          helpText: "",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "arquivo_historico_escolar",
          label: "Arquivo Histórico escolar (Frente)",
          helpText: "Envie apenas a frente do documento.",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "arquivo_historico_escolar_verso",
          label: "Arquivo Histórico escolar (Verso)",
          helpText: "Envie apenas o verso do documento.",
          component: "InputArquivo",
          type: "file",
          defaultValue: [],
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "outros-assuntos",
    label: "Outros Assuntos",
    prazo: "48hrs",
    prazo_minutos: 2880,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "assunto",
          label: "Descreva o assunto",
          helpText: "",
          component: "InputMultText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "inclusao-no-salvador-card",
    hideIn: "/setor/secretaria",
    label: "Inclusão no salvador card",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "nome_mae",
          label: "Nome da mãe",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "data_nascimento",
          label: "Data de nascimento",
          helpText: "",
          component: "InputData",
          type: "tel",
          defaultValue: "",
        },
        {
          id: "codigo_cartao",
          label: "Código do cartão",
          helpText: "em caso de revalidação ou 2ª via.",
          component: "InputText",
          type: "tel",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "declaracao-para-apresentacao-no-salvador-card",
    hideIn: "/setor/secretaria",
    label: "Declaração para salvador card",
    prazo: "48hrs",
    prazo_minutos: 2880,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "nome_mae",
          label: "Nome da mãe",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
  {
    id: "problemas-com-o-salvador-card",
    hideIn: "/setor/secretaria",
    label: "Problemas com o salvador card",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "nome_mae",
          label: "Nome da mãe",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "problema",
          label: "Descreva o problema",
          helpText: "",
          component: "InputMultText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
];